import React from 'react';

// The CSS content is now moved back into this component file.
// Class names have been prefixed with 'c1pg-' for uniqueness.
const internalCSS = `
  /* --- Main Page Container --- */
  .c1pg-chapter-page-container {
    background-color: #fff; /* White background for the whole page */
    font-family: 'Poppins', 'Open Sans', sans-serif; /* Consistent font */
  }

  /* --- 1. Top Banner Section --- */
  .c1pg-chapter-top-banner {
    position: relative;
    width: 100%;
    height: 350px; /* Fixed height for the banner */
    overflow: hidden;
    display: flex;
    flex-direction: column; /* Stack items vertically */
    justify-content: center; /* Center vertically */
    background-color: #1a1a1a; /* Fallback background */
    padding-left: 1rem; /* Padding for the content */
    padding-right: 1rem;
  }

  .c1pg-chapter-banner-bg-img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center center;
    opacity: 0.5; /* Dim the image */
  }

  .c1pg-chapter-banner-content {
    position: relative;
    z-index: 1;
    color: #fff;
    text-align: left;
    max-width: 1140px; /* Max width for content */
    margin: 0 auto; /* Center content horizontally */
    width: 100%; /* Ensure content takes full width within max-width */
  }

  .c1pg-chapter-badge {
    background-color: #dc3545; /* Red color */
    color: #fff;
    font-size: 0.9rem;
    font-weight: 600;
    padding: 0.2rem 0.75rem;
    border-radius: 4px;
    display: inline-block; /* Allows padding and margin */
    margin-bottom: 0.75rem;
  }

  .c1pg-chapter-main-title {
    font-size: 1.2rem;
    font-weight: 700;
    line-height: 1.2;
    margin-bottom: 0;
  }

  /* --- 2. Bulleted List Section --- */
  .c1pg-chapter-list-section {
    padding: 4rem 1rem;
    background-color: #fff;
  }

  .c1pg-chapter-list-container {
    max-width: 960px; /* Align with banner content */
    margin: 0 auto;
    width: 100%;
  }

  .c1pg-chapter-list {
    list-style-type: disc; /* Default bullet style */
    padding-left: 1.5rem; /* Standard indent for list */
  }

  .c1pg-chapter-list li {
    font-size: 1.15rem;
    line-height: 1.8;
    color: #333;
    margin-bottom: 0.5rem; /* Space between list items */
  }

  /* --- Responsive Adjustments --- */
  @media (max-width: 991.98px) { /* Tablets */
    .c1pg-chapter-top-banner {
      height: 300px;
    }
    .c1pg-chapter-main-title { /* Corrected from chapter-banner-title */
      font-size: 2.4rem;
    }
    .c1pg-chapter-list li {
      font-size: 1.05rem;
      line-height: 1.7;
    }
  }

  @media (max-width: 767.98px) { /* Mobile Devices */
    .c1pg-chapter-top-banner {
      height: 130px;
      justify-content: flex-start; /* Align content to bottom for mobile banner */
      padding-bottom: 1.5rem;
      padding-left: 0.75rem;
      padding-right: 0.75rem;
    }
    .c1pg-chapter-banner-content {

    }
    .c1pg-chapter-badge {
      font-size: 0.8rem;
      padding: 0.15rem 0.5rem;
      margin-bottom: 0.5rem;
    }
    .c1pg-chapter-main-title {
      font-size: 1.2rem;
      line-height: 1.1;
    }
    .c1pg-chapter-list-section {
      padding: 2rem 0.75rem;
    }
    .c1pg-chapter-list {
      padding-left: 1rem; /* Reduce indent on mobile */
    }
    .c1pg-chapter-list li {
      font-size: 0.95rem; /* Smaller text on mobile */
      line-height: 1.6;
      margin-bottom: 0.4rem;
    }
  }
`;

const chapterContent = [
  "Introduction to Ethical Hacking and Cyber Security",
  "Career's in ethical hacking and cyber security",
  "Types of hackers",
  "Roadmap to become an ethical hacker",
  "Steps followed by black hat hackers",
  "Steps followed by white hat hackers",
  "Introduction to penetration testing",
  "Types of penetration testing",
  "Fundamentals of Indian IT Act",
  "IPC Sections, Penalties and Punishments for cyber crimes",
  "Top 10 hackers and their skills",
  "Top 10 cyber attacks the world has faced",
];

const Chapter1Page = () => {
  return (
    <>
      {/* The <style> tag is now used to inject the CSS string */}
      <style>{internalCSS}</style>
      
      <div className="c1pg-chapter-page-container">
        
        {/* --- 1. Top Banner Section --- */}
        <div className="c1pg-chapter-top-banner">
          <img 
            src="https://skillsuprise.com/data/cyberPDF/chapters/chapter1.png" 
            alt="Chapter 1 Background" 
            className="c1pg-chapter-banner-bg-img" 
          />
          <div className="c1pg-chapter-banner-content">
              <span className="c1pg-chapter-badge mt-4">Chapter1</span>
            <h1 className="c1pg-chapter-main-title">
              Introduction to ethical hacking & cyber security
            </h1>

                      

          </div>
        </div>
        
        {/* --- 2. Bulleted List Section --- */}
        <div className="c1pg-chapter-list-section">
          <div className="c1pg-chapter-list-container">
            <ul className="c1pg-chapter-list">
              {chapterContent.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>
        </div>
        
      </div>
    </>
  );
};

export default Chapter1Page;

